import { render, staticRenderFns } from "./apportionmentTaxesEditedItem.vue?vue&type=template&id=82d35b54&scoped=true&"
import script from "./apportionmentTaxesEditedItem.vue?vue&type=script&lang=js&"
export * from "./apportionmentTaxesEditedItem.vue?vue&type=script&lang=js&"
import style0 from "./apportionmentTaxesEditedItem.vue?vue&type=style&index=0&id=82d35b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d35b54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VCol,VContainer,VRow,VSelect,VTextField,VTextarea})
